export default __webpack_public_path__ + "static/filmmaker-logos-883ef1bebcaff853226a9b2a9175b5eb.png";